<script>
export default {
  data() {
    return {
      menu_is_open: false
    }
  }
}
</script>

<template>
  <div class="navbar is-fixed-top">
    <div class="navbar-brand">
      <router-link class="navbar-item"
        to="/"
        @click.native="menu_is_open = false">
        <strong>ADMIN TWU</strong>
      </router-link>

      <div
        class="navbar-burger"
        @click="menu_is_open = !menu_is_open">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div
      class="navbar-menu"
      :class="{'is-active': menu_is_open}">
      <div class="navbar-end">
        <router-link class="navbar-item"
          @click.native="menu_is_open = false"
          :to="{name: 'stats'}">
          Statistiques
        </router-link>

        <router-link class="navbar-item"
          @click.native="menu_is_open = false"
          :to="{name: 'challenge_list'}">
          Challenges
        </router-link>

        <router-link class="navbar-item"
          @click.native="menu_is_open = false"
          :to="{name: 'job_list'}">
          Emplois
        </router-link>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Ajouter...
          </a>

          <div class="navbar-dropdown">
            <router-link class="navbar-item"
              @click.native="menu_is_open = false"
              :to="{name: 'challenge_add'}">
              Ajouter un Challenge
            </router-link>

            <router-link class="navbar-item"
              @click.native="menu_is_open = false"
              :to="{name: 'job_add'}">
              Ajouter un Emploi
            </router-link>
          </div>
        </div>

        <div class="navbar-item"
          @click.native="menu_is_open = false">
          <button class="button is-danger"
            @click="$auth.logout()">
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/AppHeader.vue